<template>
	<div class="comments" >
    <van-row class="my_guardian">
      <van-col span="22" offset="1" v-if="is_list">
        <van-list
          v-model="loading"
          :finished="finished"
          :immediate-check="false"
          :finished-text="$t('onLoad.finished_text')"
          @load="onLoad"
          :offset="10"
        >
          <van-cell v-for="t in list" :key="t.id">
            <van-col span="24" class="my_guardian_type">
              <van-col span="10" class="my_guardian_type_img">
                <van-image round width="5em" height="5em" :src="t.avatar" fit="cover"/>
                <div class="my_guardian_type_ava">
                  <img src="../assets/img/guard_u.png" alt="">
                </div>
              </van-col>
              <van-col span="14" class="my_guardian_center">
                <van-col span="24" class="my_guardian_center_name">{{ t.user_nickname }}</van-col>
                <van-col span="10" class="my_guardian_center_age"><img src="../assets/img/13.png" /> {{t.age}} {{ $t('user.Age') }}</van-col>
                <van-col span="10" offset="1" class="my_guardian_center_city" v-if="t.province">{{t.province}}</van-col>
                <van-col span="24" class="my_guardian_center_title">{{ t.title }}</van-col>
                <van-col span="24" class="my_guardian_center_time">{{ t.endtime }} {{ $t('other.expire')}}</van-col>
              </van-col>
            </van-col>
          </van-cell>
        </van-list>
      </van-col>
      <van-col span="24" v-else>
        <van-col span="24" class="no-data">
          <img src="../assets/img/zwsl.png"/>
        </van-col>
        <van-col span="24" class="no-data-name" >{{ $t('onLoad.No_record') }}</van-col>
      </van-col>
    </van-row>
	</div>
</template>
<script>
	//请求接口组件
  import '@/assets/css/style.css'
  import Toast from "vant/lib/toast"
	import axios from 'axios'
	export default {
		data(){
			 return {
          finished: false,
          loading: false,
          is_list: true,
				  list: [],
          page: 1
        }
		},
		created: function() {
		  this.list = []
			this.convert();
			document.title = this.$t('title.guardian')
		},
		methods: {
      onLoad() {
        this.convert()
      },
      convert: function() {
        const uid = this.$route.query.uid
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + "mapi/public/index.php/api/guardian_api/vue_guardian",{ params:{ uid:uid,token:token,page: this.page }}).then(res => {
          console.log(res.data);
          if (res.data.code == 1) {
            if (res.data.data.length > 0) {
              for (let i = 0; i < res.data.data.length; i++) {
                this.list.push(res.data.data[i]);
              }
              this.is_list = true
              this.page = this.page + 1
              this.loading = false
            } else {
              if(this.page == 1) {
                this.is_list = false
              }
              this.loading = true
              this.finished =true
            }
          } else {
            if(this.page == 1) {
              this.is_list = false
            }
            this.loading = true
            if(this.page !== 1) {
              Toast(this.$t('onLoad.No_data_available'))
            }
          }
        })
      }
    }
	}
</script>



// WEBPACK FOOTER //
// src/components/guardian.vue